var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-6 offset-lg-3 col-12 text-center p-0" },
        [
          _c("div", { staticClass: "card shadow-sm" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-left" }, [
              _vm._v("2. โปรดถือบัตรประจำตัวประชาชนและถ่ายรูปคู่กับบัตรประชาชน")
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("picture-input", {
                  ref: "pictureInput",
                  attrs: {
                    width: "400",
                    height: "400",
                    accept:
                      "image/jpeg,image/png,image/gif,image/svg,image/webp",
                    size: "5",
                    removable: true,
                    customStrings: {
                      upload: "<p>อัพโหลดเรียบร้อย</p>",
                      drag: "อัพโหลดรูป",
                      tap: "อัพโหลดรูป",
                      change: "เปลี่ยนรูป",
                      remove: "ลบรูป"
                    },
                    zIndex: 1000
                  },
                  on: { change: _vm.onChange, remove: _vm.onRemove }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._m(2)
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("p", { staticClass: "text-center", staticStyle: { margin: "0px" } }, [
        _vm._v("ผู้กู้สินเชื่อ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("p", { staticClass: "h6" }, [
        _vm._v(
          "กรุณายืนยันตัวตนผู้กู้และผู้คำประกัน เพื่อทำการยื่นขอสินเชื่อเงินสดผ่าน App"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-5" }, [
        _c("p", [_vm._v("ถ่ายรูปคู่กับบัตรประชาชน")]),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-fluid pa-2",
          attrs: { src: "/static/img/nimcap/IdCard2.png", alt: ".." }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-7" }, [
        _c("ul", [
          _c("li", { staticClass: "list-text" }, [
            _vm._v(" บัตรต้องไม่บังใบหน้าส่วนใดส่วนหนึ่ง")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-text" }, [
            _vm._v(" อย่าใส่หมวกหรือแว่นตาดำ")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-text" }, [
            _vm._v(" อย่าใส่ที่คาดผมหรือเครื่องประดับ")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-text" }, [
            _vm._v(" อย่าถ่ายแค่ครึ่งใบหน้า")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-text" }, [
            _vm._v(" รูปต้องชัดเจนให้ตัวอักษรบนบัตร")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc7c6f94", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc7c6f94","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Borrower/Step5.vue
// module id = 2278
// module chunks = 0